import React from 'react';
import { Chip } from '@mui/material';
import { colors, spacing, radius, height, typographyScale, TypographyVariant } from 'common/theme';

export const CHIP_VARIANT = {
  PRIMARY: 'primary',
  OUTLINED: 'outlined',
};

export const ChipHot = ({
  label,
  icon,
  onClick,
  variant = CHIP_VARIANT.OUTLINED,
  testID,
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case CHIP_VARIANT.PRIMARY:
        return {
          backgroundColor: colors.system.brand.primary,
          color: colors.system.text.inverse,
          '& .MuiChip-icon': {
            color: colors.system.text.inverse,
          },
          '&:hover': {
            backgroundColor: colors.system.brand.primary,
            opacity: 0.9,
          },
        };
      case CHIP_VARIANT.OUTLINED:
      default:
        return {
          backgroundColor: colors.palette.white,
          border: `1px solid ${colors.palette.blueAlpha200}`,
          color: colors.system.text.primary,
          '& .MuiChip-icon': {
            color: colors.system.text.primary,
          },
          '&:hover': {
            backgroundColor: colors.system.brand.primary,
            borderColor: colors.system.brand.primary,
            color: colors.system.text.inverse,
            '& .MuiChip-icon': {
              color: colors.system.text.inverse,
            },
          },
        };
    }
  };

  return (
    <Chip
      testId={testID}
      label={label}
      icon={icon}
      onClick={onClick}
      {...props}
      sx={{
        borderRadius: `${radius.lg}px`,
        fontSize: typographyScale[TypographyVariant.LabelMediumLarge].fontSize,
        padding: `${spacing.md}px ${spacing.xl}px`,
        height: height.lg,
        gap: `${spacing.lg}px`,
        '& .MuiChip-label': {
          padding: 0,
        },
        '& .MuiChip-icon': {
          marginLeft: 0,
          marginRight: 0,
        },
        ...getVariantStyles(),
      }}
    />
  );
};

export default ChipHot;

